import { TradeOrderListPanel, type TradeOrderData } from "../TradeOrderComponentPrimitives";

export interface LogisticsTrackingProps {
    items?: TradeOrderData[];
    onSelect?: (item: TradeOrderData) => void;
}

/** 物流跟踪展示运单节点、船舶和状态，点击行回调旧版详情入口。 */
export default function LogisticsTracking({ items = [], onSelect }: LogisticsTrackingProps) {
    return (
        <TradeOrderListPanel
            title="物流跟踪"
            items={items}
            onSelect={onSelect}
            columns={[
                { label: "运单编号", key: "id" },
                { label: "船舶", key: "shipName" },
                { label: "节点时间", key: "operateTime" },
                { label: "当前状态", key: "state" },
                { label: "节点说明", key: "remark" }
            ]}
        />
    );
}
